import Required from "components/Required/required.component";
import Table from "components/Table/table.component";
import Title from "components/Title/title.component";
import { PRESTACAO_CONTAS_PERMISSIONS } from "constants/index";
import { ErrorMessage, Form, Formik } from "formik";
import PropTypes from "prop-types";
import React, { Component, Fragment } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import Button from "../../../components/Button/button.component";
import Input from "../../../components/Input/input.component";
import Subtitle from "../../../components/Subtitle/subtitle.component";
import { PrestacaoContaValidationSchema } from "../analisePrestacao.validate";

class AnalisePrestacaoSubChefia extends Component {
	columnsDocumentos = [{ title: "Nome", property: "nome" }];

	actionsDocumentos = [
		{
			name: "Download",
			icon: "fas fa-download",
			action: item => this.props.downloadFile(item)
		},
		{
			name: "Excluir",
			icon: "fas fa-trash-alt",
			action: item => this.props.removeUpload(item)
		}
	];

	render = () => {
		const {
			state,
			handleSubmit,
			handleInputChange,
			upload,
			handleRichText,
			handleCancelar
		} = this.props;
		return (
			<Fragment>
				<div className="card mt-2">
					<div className="card-body">
						<div className="card-title">
							<Title>Análise SUBCHEFIA</Title>
							<hr />
						</div>

						<Formik
							initialValues={state.prestacaoConta}
							enableReinitialize
							onSubmit={handleSubmit}
							validationSchema={PrestacaoContaValidationSchema}
							render={({ values }) => (
								<Form>
									<div className="container">
										<span>
											Selecionar uma das opções:{" "}
											<Required />
										</span>
										<hr />
										<div className="row mb-5">
											<div className="col-md-6">
												<div className="form-check form-check-inline">
													<Input
														id="radio_1"
														name="isRevisao"
														type="radio"
														value
														onChange={
															handleInputChange
														}
													/>
													<label
														htmlFor="radio_1"
														className="form-check-label pointer-text"
													>
														Solicitar revisão
													</label>
												</div>
											</div>
											<div className="col-md-6">
												<div className="form-check form-check-inline">
													<Input
														id="radio_2"
														name="isRevisao"
														value={false}
														type="radio"
														onChange={
															handleInputChange
														}
													/>
													<label
														htmlFor="radio_2"
														className="form-check-label pointer-text"
													>
														Arquivar processo
													</label>
												</div>
											</div>
											<ErrorMessage
												name="isRevisao"
												render={msg => (
													<div className="mt-2 ml-3">
														<span className="text-danger">
															{" "}
															{msg}
														</span>
													</div>
												)}
											/>
										</div>
									</div>
									<div className="row container mb-3">
										<div className="col-md-12">
											<span>Anexar Arquivo:</span>
											<hr />
											<div className="mt-2">{upload}</div>
										</div>
									</div>
									<div className="container">
										<Subtitle>
											Documentos carregados
										</Subtitle>
										<hr />
										<Table
											align="left"
											actions={this.actionsDocumentos}
											columns={this.columnsDocumentos}
											data={
												state.prestacaoConta
													.documentos || []
											}
											showPaginate={false}
											emptyMessage="Não há registros cadastrados."
											emptyColSpan={
												this.columnsDocumentos.length +
												1
											}
											permission={
												PRESTACAO_CONTAS_PERMISSIONS.ANALISAR_SUB_CHEFE
											}
										/>
									</div>

									<div
										key={state.key}
										className="container mb-3"
									>
										<Subtitle>
											Observações:{" "}
											{state.prestacaoConta.isRevisao ===
												"true" && <Required />}{" "}
										</Subtitle>
										<hr />
										<ReactQuill
											name="observacoes"
											defaultValue={
												state.prestacaoConta.observacoes
											}
											onChange={handleRichText}
										/>
										<ErrorMessage
											name="observacoes"
											render={msg => (
												<div className="mb-1">
													<span className="text-danger">
														{" "}
														{msg}
													</span>
												</div>
											)}
										/>
									</div>
									<div className="row mt-3 mb-3">
										<div className="col-12">
											<div className="float-left">
												<Button
													onClick={() =>
														handleCancelar()
													}
													cancel
													type="button"
													text="Cancelar"
													icon="fas fa-times"
												/>
											</div>
											<div className="float-right">
												<Button
													type="submit"
													primary
													text="Finalizar"
													icon="fas fa-check"
												/>
											</div>
										</div>
									</div>
								</Form>
							)}
						/>
					</div>
				</div>
			</Fragment>
		);
	};
}
export default AnalisePrestacaoSubChefia;

AnalisePrestacaoSubChefia.propTypes = {
	upload: PropTypes.node.isRequired,
	handleInputChange: PropTypes.func.isRequired,
	handleSubmit: PropTypes.func.isRequired,
	handleRichText: PropTypes.func.isRequired,
	handleCancelar: PropTypes.func.isRequired,
	downloadFile: PropTypes.func.isRequired,
	state: PropTypes.shape({
		prestacaoConta: PropTypes.shape({
			observacoes: PropTypes.string.isRequired,
			documentos: PropTypes.array.isRequired,
			isRevisao: PropTypes.bool
		}).isRequired
	}).isRequired
};
